// The 'productTours' domain: the asset area these commands operate in.
export const PRODUCT_TOUR_DOMAIN = 'productTours' as const;

export const productTourDomainDescription =
  'Interactive, in-app guided tours that walk the user through a feature step by step. ' +
  'Starting a tour changes only what is shown on screen and does not fetch, calculate, or ' +
  'report data. Start a tour only when the user clearly asks to be shown, guided, or walked ' +
  'through one specific tour; when they ask what is available, or ask for a tour ' +
  'without identifying one, list the tours by name and ask which one they want. The tours ' +
  "this particular user can start are the ones in the startProductTour command's " +
  "'availableTours' context — never offer or name a tour that is not in it.";
